import HeaderOne from "../components/HeaderOne";
import DataBase from "../components/DataBase";
import FooterOne from "../components/FooterOne";

const DataBasePage = () => {
  return (
    <>
      <HeaderOne />
      <DataBase />
      <FooterOne />
    </>
  );
};

export default DataBasePage;
